import { useState, useEffect } from 'react';

export default function GoldFrame() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[1] pointer-events-none">
      {/* Top border */}
      <div
        className={`absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary-400 to-transparent transition-all duration-1000 ${
          mounted ? 'opacity-100' : 'opacity-0'
        }`}
      />
      {/* Bottom border */}
      <div
        className={`absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary-400 to-transparent transition-all duration-1000 delay-300 ${
          mounted ? 'opacity-100' : 'opacity-0'
        }`}
      />
      {/* Left border */}
      <div
        className={`absolute top-0 bottom-0 left-0 w-[2px] bg-gradient-to-b from-transparent via-primary-400 to-transparent transition-all duration-1000 delay-150 ${
          mounted ? 'opacity-100' : 'opacity-0'
        }`}
      />
      {/* Right border */}
      <div
        className={`absolute top-0 bottom-0 right-0 w-[2px] bg-gradient-to-b from-transparent via-primary-400 to-transparent transition-all duration-1000 delay-150 ${
          mounted ? 'opacity-100' : 'opacity-0'
        }`}
      />

      {/* Corner accents */}
      <div className="absolute top-0 left-0 w-8 h-8">
        <div
          className={`absolute top-0 left-0 w-full h-[2px] bg-primary-400 transition-all duration-700 delay-500 ${
            mounted ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
          style={{ transformOrigin: 'left' }}
        />
        <div
          className={`absolute top-0 left-0 h-full w-[2px] bg-primary-400 transition-all duration-700 delay-500 ${
            mounted ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'
          }`}
          style={{ transformOrigin: 'top' }}
        />
      </div>

      <div className="absolute top-0 right-0 w-8 h-8">
        <div
          className={`absolute top-0 right-0 w-full h-[2px] bg-primary-400 transition-all duration-700 delay-600 ${
            mounted ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
          style={{ transformOrigin: 'right' }}
        />
        <div
          className={`absolute top-0 right-0 h-full w-[2px] bg-primary-400 transition-all duration-700 delay-600 ${
            mounted ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'
          }`}
          style={{ transformOrigin: 'top' }}
        />
      </div>

      <div className="absolute bottom-0 left-0 w-8 h-8">
        <div
          className={`absolute bottom-0 left-0 w-full h-[2px] bg-primary-400 transition-all duration-700 delay-700 ${
            mounted ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
          style={{ transformOrigin: 'left' }}
        />
        <div
          className={`absolute bottom-0 left-0 h-full w-[2px] bg-primary-400 transition-all duration-700 delay-700 ${
            mounted ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'
          }`}
          style={{ transformOrigin: 'bottom' }}
        />
      </div>

      <div className="absolute bottom-0 right-0 w-8 h-8">
        <div
          className={`absolute bottom-0 right-0 w-full h-[2px] bg-primary-400 transition-all duration-700 delay-800 ${
            mounted ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
          style={{ transformOrigin: 'right' }}
        />
        <div
          className={`absolute bottom-0 right-0 h-full w-[2px] bg-primary-400 transition-all duration-700 delay-800 ${
            mounted ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'
          }`}
          style={{ transformOrigin: 'bottom' }}
        />
      </div>
    </div>
  );
}